/* eslint-disable react/prop-types */
import React, { useRef } from 'react';
import { Modal, message } from 'antd';
import ProTable from '@ant-design/pro-table';
import { pageDeductPlan } from '@/services/channel';

/**
 * 先用后付记录弹窗
 * ------------------------------------------------------------------
 * 从 merchantInfo 里**原样抽出**（列定义、请求参数、分页配置均未改动）。
 * 抽出来的原因：框架更新后「保证金余额 / 在途 / 可提现 / 累计提现」这四个
 * 金额从「基础信息」移到了「资金与结算」，而本弹窗的入口原本就挂在
 * 保证金余额旁边的图标上——入口要跟着金额走，所以弹窗必须能独立挂载。
 */
const columns = [
  { title: '签约/解约时间', dataIndex: 'signOrUnSignTime' },
  { title: '签约状态', dataIndex: 'signStatusStr' },
  { title: '扣款发起时间', dataIndex: 'deductTime' },
  { title: '扣款金额', dataIndex: 'deductAmountStr' },
  { title: '扣款状态', dataIndex: 'deductStatusStr' },
];

const DeductPlanModal = ({ tenantId, visible, setVisible }) => {
  const actionRef = useRef(null);

  return (
    /* 项目是 antd 4.x：受控属性是 visible（open 是 v5 的改名），
       同时传两个属于冗余 —— 只保留 visible。 */
    <Modal
      title="先用后付记录"
      visible={visible}
      width={800}
      onCancel={() => setVisible(false)}
      footer={[]}
    >
      <ProTable
        columns={columns}
        actionRef={actionRef}
        request={async (params) => {
          const { data, page, code, msg } = await pageDeductPlan({
            requestData: { ...params, tenantId },
            page: {
              currentPage: params.current,
              pageSize: params.pageSize,
            },
          });
          if (code !== '00000') {
            /* 不能静默失败：原先只回一个成功标记，用户会看到空列表却不知原因（评分清单 #3） */
            message.error(msg || '读取先用后付记录失败');
            return { success: false };
          }
          // page 可能缺失（接口结构微调时）：直接 page.count 会 NPE，这里兜底 0
          return { data, success: true, total: page?.count || 0 };
        }}
        rowKey="wxUserId"
        search={false}
        toolBarRender={false}
        pagination={{ defaultPageSize: 5 }}
        dateFormatter="string"
      />
    </Modal>
  );
};

export default DeductPlanModal;
